import React, { useState, useEffect } from "react";
import BGPH1 from "../../assets/images/backgrounds/ContactUs.png";
import { Link } from "react-router-dom";
import { postReferrals } from "../../Services/API/Post"; // Assuming you'll create this endpoint

const ServiceReferral = () => {
  const [msg, setMsg] = useState(null);
  
  // Single formData state instead of multiple states
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    addressLine1: "",
    city: "",
    state: "",
    postalCode: "",
    contactPerson: "",
    phone: "",
    email: "",
    supportType: [],
    referrerName: "",
    referrerPhone: "",
    referrerEmail: "",
    hasNdis: "",
    additionalInfo: "",
    hearAboutUs: ""
  });

  // Error states
  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    gender: false,
    dob: false,
    addressLine1: false,
    city: false,
    state: false,
    postalCode: false,
    contactPerson: false,
    phone: "",
    supportType: false,
    referrerName: false,
    referrerPhone: "",
    hasNdis: false,
    hearAboutUs: false
  });

  useEffect(() => {
    if (msg !== null) {
      setTimeout(() => {
        setMsg(null);
      }, 6000);
    }
  }, [msg]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // Clear error for this field
    setErrors({
      ...errors,
      [name]: false
    });
  };

  const handleSupportTypeChange = (type) => {
    let updatedSupportTypes;
    if (formData.supportType.includes(type)) {
      updatedSupportTypes = formData.supportType.filter(item => item !== type);
    } else {
      updatedSupportTypes = [...formData.supportType, type];
    }
    
    setFormData({
      ...formData,
      supportType: updatedSupportTypes
    });
    
    setErrors({
      ...errors,
      supportType: false
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const phoneRegex = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

    // Reset errors
    let newErrors = {};
    let hasError = false;

    // Validate required fields
    if (formData.firstName === "") {
      newErrors.firstName = true;
      hasError = true;
    }
    if (formData.lastName === "") {
      newErrors.lastName = true;
      hasError = true;
    }
    if (formData.gender === "") {
      newErrors.gender = true;
      hasError = true;
    }
    if (formData.dob === "") {
      newErrors.dob = true;
      hasError = true;
    }
    if (formData.addressLine1 === "") {
      newErrors.addressLine1 = true;
      hasError = true;
    }
    if (formData.city === "") {
      newErrors.city = true;
      hasError = true;
    }
    if (formData.state === "") {
      newErrors.state = true;
      hasError = true;
    }
    if (formData.postalCode === "") {
      newErrors.postalCode = true;
      hasError = true;
    }
    if (formData.contactPerson === "") {
      newErrors.contactPerson = true;
      hasError = true;
    }
    
    // Validate phone
    if (!phoneRegex.test(formData.phone)) {
      if (formData.phone === "") {
        newErrors.phone = "This field is required";
      } else {
        newErrors.phone = "Please enter a valid phone number";
      }
      hasError = true;
    }

    // Validate referrer phone
    if (formData.referrerPhone && !phoneRegex.test(formData.referrerPhone)) {
      newErrors.referrerPhone = "Please enter a valid phone number";
      hasError = true;
    }

    if (formData.supportType.length === 0) {
      newErrors.supportType = true;
      hasError = true;
    }
    if (formData.referrerName === "") {
      newErrors.referrerName = true;
      hasError = true;
    }
    if (formData.hasNdis === "") {
      newErrors.hasNdis = true;
      hasError = true;
    }
    if (formData.hearAboutUs === "") {
      newErrors.hearAboutUs = true;
      hasError = true;
    }

    setErrors(newErrors);

    if (!hasError) {
      const dataToSubmit = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        gender: formData.gender,
        dob: formData.dob,
        address: {
          addressLine1: formData.addressLine1,
          city: formData.city,
          state: formData.state,
          postalCode: formData.postalCode
        },
        contactPerson: formData.contactPerson,
        phone: formData.phone,
        email: formData.email,
        supportType: formData.supportType,
        referrer: {
          name: formData.referrerName,
          phone: formData.referrerPhone,
          email: formData.referrerEmail
        },
        hasNdis: formData.hasNdis,
        additionalInfo: formData.additionalInfo,
        hearAboutUs: formData.hearAboutUs
      };

      console.log("Submitting form data:", dataToSubmit);

      postReferrals(dataToSubmit)
        .then((res) => {
          console.log("Response:", res);
          setMsg("Your referral form has been successfully submitted");
          
          // Reset form
          setFormData({
            firstName: "",
            lastName: "",
            gender: "",
            dob: "",
            addressLine1: "",
            city: "",
            state: "",
            postalCode: "",
            contactPerson: "",
            phone: "",
            email: "",
            supportType: [],
            referrerName: "",
            referrerPhone: "",
            referrerEmail: "",
            hasNdis: "",
            additionalInfo: "",
            hearAboutUs: ""
          });
        })
        .catch((error) => {
          console.log("Error:", error);
          setMsg("There was an error submitting your form. Please try again.");
        });
    }
  };

  // Inline styles for the date picker
const datePickerStyle = {
    padding:"16px",
    borderRadius: "5px",
    border: "1px solid #f2ede9",
    width: "100%",
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: "14px",
    color: "#333",
    backgroundColor: "#f2ede9",
};

  return (
    <>
      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundImage: `url(${BGPH1})` }}
        ></div>
        <div className="container">
          <ul className="thm-breadcrumb list-unstyled">
            {/* <li><Link to="/">Home</Link></li>
            <li><span>Service Referral</span></li> */}
          </ul>
          <h2>Service Referral Form</h2>
        </div>
      </section>
      <section className="contact-one pt-120 pb-120">
        <div className="container">
          <div className="row">

            <div className="">
              <form
                className="form-one contact-form-validated"
                onSubmit={handleSubmit}
              >
                <div className="row row-gutter-y-20 row-gutter-x-20">
                  {/* Participant Name */}
                  <div className="col-12">
                    <h4>Participant Information</h4>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="First Name *"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                    />
                    {errors.firstName && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="Last Name *"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                    />
                    {errors.lastName && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>

                  {/* Gender */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="gender"
                        value={formData.gender}
                        onChange={handleInputChange}
                      >
                        <option value="">Gender *</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    {errors.gender && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>

                  {/* Date of Birth with inline styles */}
                  <div className="col-md-6">
                    <input
                      type="date"
                      placeholder="Date of Birth *"
                      name="dob"
                      value={formData.dob}
                      onChange={handleInputChange}
                      style={datePickerStyle}
                    />
                    {errors.dob && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>

                  {/* Address */}
                  <div className="col-md-12">
                    <input
                      type="text"
                      placeholder="Address Line 1 *"
                      name="addressLine1"
                      value={formData.addressLine1}
                      onChange={handleInputChange}
                    />
                    {errors.addressLine1 && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      placeholder="City *"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                    />
                    {errors.city && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      placeholder="State / Province *"
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                    />
                    {errors.state && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      placeholder="Postal Code *"
                      name="postalCode"
                      value={formData.postalCode}
                      onChange={handleInputChange}
                    />
                    {errors.postalCode && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>

                  {/* Contact Person */}
                  <div className="col-md-12">
                    <input
                      type="text"
                      placeholder="Contact Person *"
                      name="contactPerson"
                      value={formData.contactPerson}
                      onChange={handleInputChange}
                    />
                    {errors.contactPerson && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>

                  {/* Phone and Email */}
                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="Phone Number *"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                    {errors.phone && (
                      <div className="error" style={{ color: "red" }}>
                        {errors.phone}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      placeholder="Email Address"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>

                  {/* Support Type */}
                  <div className="col-md-12">
                    <h4>What Support Are You Looking For? *</h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="supportWorker"
                            checked={formData.supportType.includes("Support Worker")}
                            onChange={() => handleSupportTypeChange("Support Worker")}
                          />
                          <label className="form-check-label" htmlFor="supportWorker">
                            Support Worker
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="supportCoordination"
                            checked={formData.supportType.includes("Support Coordination")}
                            onChange={() => handleSupportTypeChange("Support Coordination")}
                          />
                          <label className="form-check-label" htmlFor="supportCoordination">
                            Support Coordination
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="sil"
                            checked={formData.supportType.includes("SIL")}
                            onChange={() => handleSupportTypeChange("SIL")}
                          />
                          <label className="form-check-label" htmlFor="sil">
                            SIL
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="cleaning"
                            checked={formData.supportType.includes("Cleaning / Gardening")}
                            onChange={() => handleSupportTypeChange("Cleaning / Gardening")}
                          />
                          <label className="form-check-label" htmlFor="cleaning">
                            Cleaning / Gardening
                          </label>
                        </div>
                      </div>
                    </div>
                    {errors.supportType && (
                      <div className="error" style={{ color: "red" }}>
                        Please select at least one support type
                      </div>
                    )}
                  </div>

                  {/* Referrer Details */}
                  <div className="col-md-12 mt-4">
                    <h4>Referrer's Details</h4>
                  </div>
                  <div className="col-md-12">
                    <input
                      type="text"
                      placeholder="Referrer's Name *"
                      name="referrerName"
                      value={formData.referrerName}
                      onChange={handleInputChange}
                    />
                    {errors.referrerName && (
                      <div className="error" style={{ color: "red" }}>
                        This field is required
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="Contact Phone *"
                      name="referrerPhone"
                      value={formData.referrerPhone}
                      onChange={handleInputChange}
                    />
                    {errors.referrerPhone && (
                      <div className="error" style={{ color: "red" }}>
                        {errors.referrerPhone}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      placeholder="Email"
                      name="referrerEmail"
                      value={formData.referrerEmail}
                      onChange={handleInputChange}
                    />
                  </div>

                  {/* NDIS Plan */}
                  <div className="col-md-12 mt-4">
                    <h4>Do You Currently Have a NDIS Plan? *</h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="hasNdis"
                            id="ndisyes"
                            value="Yes"
                            checked={formData.hasNdis === "Yes"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="ndisyes">
                            Yes
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="hasNdis"
                            id="ndisno"
                            value="No"
                            checked={formData.hasNdis === "No"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="ndisno">
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    {errors.hasNdis && (
                      <div className="error" style={{ color: "red" }}>
                        Please select an option
                      </div>
                    )}
                  </div>

                  {/* Additional Information */}
                  <div className="col-md-12 mt-4">
                    <h4>Any Additional Relevant Information?</h4>
                    <textarea
                      placeholder="Additional Information"
                      name="additionalInfo"
                      value={formData.additionalInfo}
                      onChange={handleInputChange}
                    ></textarea>
                  </div>

                  {/* How Did You Hear About Us */}
                  <div className="col-md-12 mt-4">
                    <h4>How Did You Hear About Us? *</h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="hearAboutUs"
                            id="facebook"
                            value="Facebook"
                            checked={formData.hearAboutUs === "Facebook"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="facebook">
                            Facebook
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="hearAboutUs"
                            id="google"
                            value="Google"
                            checked={formData.hearAboutUs === "Google"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="google">
                            Google
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="hearAboutUs"
                            id="referred"
                            value="Referred"
                            checked={formData.hearAboutUs === "Referred"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="referred">
                            Referred
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="hearAboutUs"
                            id="instagram"
                            value="Instagram"
                            checked={formData.hearAboutUs === "Instagram"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="instagram">
                            Instagram
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="hearAboutUs"
                            id="advert"
                            value="Advert"
                            checked={formData.hearAboutUs === "Advert"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="advert">
                            Advert
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="hearAboutUs"
                            id="other"
                            value="Other"
                            checked={formData.hearAboutUs === "Other"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="other">
                            Other
                          </label>
                        </div>
                      </div>
                    </div>
                    {errors.hearAboutUs && (
                      <div className="error" style={{ color: "red" }}>
                        Please select an option
                      </div>
                    )}
                  </div>

                  {/* Submit Button */}
                  {msg && (
                    <div className="col-md-12">
                      <span className="error" style={{ color: "green" }}>
                        {msg}
                      </span>
                    </div>
                  )}
                  <div className="col-md-12 d-flex align-items-center mt-4">
                    <button type="submit" className="thm-btn">
                      Submit Form
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceReferral;